import { render, staticRenderFns } from "./PriceDiscount.vue?vue&type=template&id=112645d2"
import script from "./PriceDiscount.vue?vue&type=script&lang=js"
export * from "./PriceDiscount.vue?vue&type=script&lang=js"
import style0 from "./PriceDiscount.vue?vue&type=style&index=0&id=112645d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports